import React from 'react'
import { Alert } from 'shared/ui'
import { showAutoRechargeRequired } from 'entities/Billing/actions/showAutoRechargeRequired.ts'
import { useEntitiesContext } from 'entities/EntitiesExport'
import styles from './styles.module.scss'

export const ForwardCallWarningAlert = () => {
  const entities = useEntitiesContext()
  return (
    <Alert
      className={styles.alert}
      item={{
        type: 'warning',
        title: 'Auto-Recharge required',
        desc: 'To use call forwarding, enable auto-recharge',
      }}
      actions={[
        {
          variant: 'button',
          type: 'primary',
          text: 'Enable auto-recharge',
          onClick: () =>
            showAutoRechargeRequired(entities, {
              useFor: 'call forwarding',
            }),
        },
      ]}
    />
  )
}
